import DashboardService from "./DashboardService";
import UnimedService from "@/shared/services/UnimedService";

export default {
  mixins: [DashboardService, UnimedService],
  data() {
    return {
      loading: false,
      loadingGrafico: false,
      listaEstados: [],
      graficoTipoRede: [],
      graficoTipoVinculo: [],
      graficoTipoPrestador: [],
      totalPrestadoresBase: -1,
      totalPrestadores: 0,
      listaUnimed: [],
      graficoMapa: [],
      listaRegioes: [],
      objetoFiltro: new Map()
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    limparObjetoFiltro() {
      this.objetoFiltro = new Map();
    },
    reiniciarGraficos() {
      if (this.loading || this.loadingGrafico) return;

      this.limparObjetoFiltro();

      this.loading = true;
      this.inicializarEstados().finally(() => {
        this.inicializarGraficos().finally(() => {
          this.inicializarMapa().finally(() => {
            this.loading = false;
          });
        });
      });
    },
    init() {
      this.loading = true;
      this.inicializarEstados().finally(() => {
        this.inicializarRegioes().finally(() => {
          this.inicializarUnimeds().finally(() => {
            this.inicializarGraficos().finally(() => {
              this.inicializarMapa().finally(() => {
                this.loading = false;
              });
            });
          });
        });
      });
    },
    inicializarEstados() {
      return new Promise((resolve, reject) => {
        this.getEstados()
          .then(res => {
            this.listaEstados = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    inicializarGraficos() {
      return new Promise((resolve, reject) => {
        this.sleep(300).then(() => {
          this.getQuantidades(this.converterMapJson())
            .then(res => {
              const {
                total,
                tiposRede,
                tiposVinculo,
                tiposPrestador
              } = res.data;

              if (this.totalPrestadoresBase === -1) {
                this.totalPrestadoresBase = total;
              }
              this.totalPrestadores = total;
              this.graficoTipoRede = tiposRede;
              this.graficoTipoVinculo = tiposVinculo;
              this.graficoTipoPrestador = tiposPrestador;

              resolve();
            })
            .catch(() => reject());
        });
      });
    },
    inicializarUnimeds() {
      return new Promise((resolve, reject) => {
        this.getAllUnimeds()
          .then(res => {
            this.listaUnimed = res.data;
            resolve();
          })
          .catch(() => reject());
      });
    },
    inicializarMapa() {
      return new Promise((resolve, reject) => {
        this.getTotalRegiao()
          .then(res => {
            this.graficoMapa = res.data;

            this.graficoMapa.sort((a, b) => {
              return b.quantidade - a.quantidade;
            });
            resolve();
          })
          .catch(() => reject());
      });
    },
    inicializarRegioes() {
      return new Promise((resolve, reject) => {
        this.getRegioes()
          .then(res => {
            this.listaRegioes = res.data;
            resolve();
          })
          .catch(() => reject());
      });
    },
    inicializarEstadoPorRegiao() {
      return new Promise((resolve, reject) => {
        this.getEstadosRegiao(this.objetoFiltro.get("regiao"))
          .then(res => {
            this.listaEstados = res.data;
            resolve();
          })
          .catch(() => reject());
      });
    },
    /**
     * Adiciona uma chave para o filtro
     * @param { { chaveAdicao: String, value: String, sucesso: Function } } objetoAdicao
     */
    adicionarFiltro(objetoAdicao) {
      this.loadingGrafico = true;

      const {
        chaveAdicao,
        chaveRemocao,
        value,
        sucesso = () => {},
        error = () => {},
        valor
      } = objetoAdicao;

      this.objetoFiltro.set(chaveAdicao, value);

      if (valor) {
        this.objetoFiltro.set("valor", valor);
      }

      if (chaveRemocao) {
        this.objetoFiltro.delete(chaveRemocao);
      }

      this.inicializarGraficos()
        .then(() => {
          if (chaveAdicao === "regiao") {
            this.inicializarEstadoPorRegiao().then(() => {
              sucesso();
              this.gerarListaFiltro();
            });
            return;
          } else if (chaveRemocao === "regiao") {
            this.inicializarEstados().then(() => {
              sucesso();
              this.gerarListaFiltro();
            });
            return;
          }
          sucesso();
          this.gerarListaFiltro();
        })
        .catch(() => {
          error();
        })
        .finally(() => {
          this.loadingGrafico = false;
        });
    },
    /**
     * Remove uma chave do filtro
     * @param { { chaveRemocao: String, sucesso: Function } } objetoRemocao
     */
    removeFiltro(objetoRemocao) {
      const {
        chaveRemocao,
        sucesso = () => {},
        error = () => {},
        valor
      } = objetoRemocao;

      if (!this.objetoFiltro.has(chaveRemocao)) return;

      this.loadingGrafico = true;

      this.objetoFiltro.delete(chaveRemocao);

      if (valor === -1) {
        this.objetoFiltro.delete("valor");
      }

      this.inicializarGraficos()
        .then(() => {
          if (chaveRemocao === "regiao") {
            this.inicializarEstados().then(() => {
              sucesso();
              this.gerarListaFiltro();
            });
            return;
          }
          sucesso();
          this.gerarListaFiltro();
        })
        .catch(() => {
          error();
        })
        .finally(() => {
          this.loadingGrafico = false;
        });
    },
    converterMapJson() {
      let obj = {};

      this.objetoFiltro.forEach((value, key) => {
        var keys = key.split("."),
          last = keys.pop();
        keys.reduce((r, a) => (r[a] = r[a] || {}), obj)[last] = value;
      });
      return obj;
    },
    gerarListaFiltro() {
      let listaFiltro = [];

      this.objetoFiltro.forEach((value, key) => {
        if (key === "valor") return;
        let valorTemp = this.chaveValorTipos[value];

        if (key === "cdUnimed") {
          valorTemp = this.listaUnimed.find(e1 => e1.id === value)
            .textoExibicao;
        } else if (key === "estado") {
          valorTemp = this.listaEstados.find(e2 => e2.chave === value)
            .descricao;
        }

        listaFiltro.push({
          nome: this.chaveValorGraficos[key],
          valor: valorTemp
        });
      });

      this.$emit("mudar-lista-filtro", {
        arr: listaFiltro,
        callback: () => this.reiniciarGraficos()
      });
    }
  },
  computed: {
    chaveValorGraficos() {
      return {
        tipoPrestador: "Tipo de Prestador",
        tipoRede: "Tipo de Rede",
        tipoVinculo: "Tipo de Vínculo",
        cdUnimed: "Unimed",
        estado: "Estado",
        regiao: "Região"
      };
    },
    chaveValorTipos() {
      const chaveValorPrestador = this.graficoTipoPrestador.map(e => ({
        [e.tipo.chave]: e.tipo.descricao
      }));
      const chaveValorVinculo = this.graficoTipoVinculo.map(e => ({
        [e.tipo.chave]: e.tipo.descricao
      }));
      const chaveValorRede = this.graficoTipoRede.map(e => ({
        [e.tipo.chave]: e.tipo.descricao
      }));
      const chaveValorRegiao = this.listaRegioes.map(e => ({
        [e.chave]: e.descricao
      }));

      const chavesConcat = [
        ...chaveValorPrestador,
        ...chaveValorVinculo,
        ...chaveValorRede,
        ...chaveValorRegiao
      ];

      return Object.assign({}, ...chavesConcat);
    }
  }
};
